import {IdObjectsWithId} from "../../../utils";
import {IActiveFolders} from "./files/types";
import isEqual from "lodash/isEqual"

export interface IBannerTemplate {
    id: string;
    parentId?: string;
    designBannerVariablesId: string;
    feedBannerVariablesId: string;
    sassFolderId: string;
    htmlFolderId: string;
    organizationId?: string
    campaignIds?: string[];
    adLabelIds?: string[];
    isMaster?: boolean;
    name: string;
    s3Folder?: string;
    template: string;
    customCode: string;
    screenShot: string;
    created: Object;
    updated: Object;
}

export const equal = (a: IBannerTemplate, b: IBannerTemplate): boolean => {
    return a && b && a.id == b.id &&
        a.parentId == b.parentId &&
        a.designBannerVariablesId == b.designBannerVariablesId &&
        a.feedBannerVariablesId == b.feedBannerVariablesId &&
        a.sassFolderId == b.sassFolderId &&
        a.htmlFolderId == b.htmlFolderId &&
        a.organizationId == b.organizationId &&
        isEqual(a.campaignIds, b.campaignIds) &&
        isEqual(a.adLabelIds, b.adLabelIds) &&
        a.isMaster == b.isMaster &&
        a.name == b.name &&
        a.s3Folder == b.s3Folder &&
        a.template == b.template &&
        a.customCode == b.customCode
};

export interface IBannerTemplateState {
    readonly bannerTemplates: IdObjectsWithId<IBannerTemplate>;
    readonly activeBannerTemplate:  IBannerTemplate;
    readonly activeMasterBannerTemplate?: IBannerTemplate;
    readonly activeFolders: IActiveFolders;
    readonly isReloadingActiveFolders: boolean;
    readonly isLoading: boolean;
    readonly isSaving: boolean;
    readonly filter: IBannerTemplatesFilter;
}

export interface IBannerTemplatesFilter {
    readonly parentId: string | undefined;
}

